import request, { get, post } from '~/utils/request';
import { gateway, web } from '~/utils/hosts'

const apiPre = '/api/community';
export function homeNotice() {
  return get(`${apiPre}/api/notice/default`);
}
export function noticeList() {
  return get(`${apiPre}/api/notice/list`);
}
export function homeNav() {
  return get(`${apiPre}/api/app/selfhelp/list`);
}
export function home() {
  return request(`${apiPre}/api/notice/default`);
}
export function homeColumn() {
  return get(`${apiPre}/api/app/column/list`);
}

export function classQuestion(data) {
  return get(`${apiPre}/api/app/help/classquestion`, data);
}

export function columnQuestion(data) {
  return get(`${apiPre}/api/app/column/question`, data);
}
export function getDetail(data) {
  return get(`${apiPre}/api/app/question/detail`, data);
}
export function postComment(data) {
  return post(`${apiPre}/api/app/question/comment`, data);
}
export function getAllProblem() {
  return get(`${apiPre}/api/app/help/allclass`);
}

export function firstclass() {
  return get(`${apiPre}/api/app/help/firstclass`);
}

export function secondclass(data) {
  return get(`${apiPre}/api/app/help/secondclass`, data);
}

export function searchMatch(data) {
  return get(`${apiPre}/api/app/question/match`, data);
}
export function searchList(data) {
  return get(`${apiPre}/api/app/question/search`, data);
}
export function searchHotList(data) {
  return get(`${apiPre}/api/app/keyword/list`, data);
}
export function getLatestFullVersion(data) {
  return get(`${gateway}/api/apppublishprod/admin/getLatestFullVersion`, data);
}

export function getCustomDownloadUrl(data) {
  return get(`${gateway}/api/apppublishprod/app/scan/code/download/url`, data);
}

/**
 * 请求nacos配置中心
 */
export function postQueryNacos(data) {
  return post(`${web}/api/community/webconfig/get`, data);
}



// WEBPACK FOOTER //
// ./src/api/index.js